// import { useQuery } from "@tanstack/react-query";
// import axios from "axios";
// import config from "configs/config";
// import apiClient from "lib/api-client";

// const fetchAICollectionDesigns = async (payload) => {
//   const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getSpecificAICollectionDesigns`, payload);
//   return response.data;
// };

// const useGetAICollectionDesigns = (payload) => {
//   return useQuery({
//     queryKey: ["aicollectiondesigns", payload],
//     queryFn: () => fetchAICollectionDesigns(payload),
//     enabled: !!payload,
//     refetchOnWindowFocus: false,
//   });
// };

// export default useGetAICollectionDesigns;

import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import config from "configs/config";
import apiClient from "lib/api-client";

const fetchAICollectionDesigns = async ({ pageParam = 1, queryKey }) => {
  const [, payload] = queryKey;

  const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getSpecificAICollectionDesigns`, {
    ...payload,
    pageNumber: pageParam, // Send page number
  });

  return {
    totalCount: response.data.designCount,
    designs: response.data.designs,
    nextPage: response.data.designs.length > 0 ? pageParam + 1 : null, // Determine if more pages exist
  };
};

const useGetAICollectionDesigns = (payload) => {
  const { enabled, ...restPayload } = payload || {};

  return useInfiniteQuery({
    queryKey: ["aicollectiondesigns", restPayload],
    queryFn: fetchAICollectionDesigns,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    enabled: enabled, // Explicit control based on passed flag
    refetchOnWindowFocus: false,
  });
};

export default useGetAICollectionDesigns;


const fetchAIBinnysSelectDesigns = async ({ pageParam = 1, queryKey }) => {
  const [, payload] = queryKey;

  const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getBinnysSelectProductDesign`, {
    ...payload,
    page: pageParam,
  });

  return {
    totalCount: response.data.designCount,
    designs: response.data.designs,
    nextPage: response.data.designs.length > 0 ? pageParam + 1 : null, 
  };
};

const fetchAINewDesigns = async ({ pageParam = 1, queryKey }) => {
  const [, payload] = queryKey;

  const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getNewDesigns`, {
    ...payload,
    page: pageParam,
  });

  return {
    totalCount: response.data.totalCount,
    designs: response.data.designs,
    nextPage: response.data.designs.length > 0 ? pageParam + 1 : null, 
  };
};

export const useGetAIBinnysSelectDesigns = (payload) => {
  const { enabled, ...restPayload } = payload || {};

  return useInfiniteQuery({
    queryKey: ["aibinnysselectdesigns", restPayload],
    queryFn: fetchAIBinnysSelectDesigns,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
}

export const useGetAINewDesigns = (payload) => {
  const { enabled, ...restPayload } = payload || {};

  return useInfiniteQuery({
    queryKey: ["aibinnysnewdesigns", restPayload],
    queryFn: fetchAINewDesigns,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

